import { useNuxtApp } from "#imports";
export function renderPageDependencies() {
  const nuxtApp = useNuxtApp();
  nuxtApp._nuxtPageDependenciesRendered = true;
  return nuxtApp.callHook("nuxt-page-dependencies:rendered");
}
